// extracted by mini-css-extract-plugin
export default {"listRowInquiries":"companyInquiries_listRowInquiries__4s9ZD"};